class CuotasVerMas {
    constructor(cuotas) {
        this.cuotas = document.querySelectorAll(cuotas);
        for (let index = 0; index < this.cuotas.length; index++) {
            if (index < 3) {
                this.cuotas[index].classList.remove("hideItem");
                this.cuotas[index].classList.add("showItem");
            } else {
                this.cuotas[index].classList.remove("showItem");
                this.cuotas[index].classList.add("hideItem");
            }
        }
    }
}

export { CuotasVerMas };
